export default __webpack_public_path__ + "static/media/checkbox-empty-disabled.icon.b636277b.svg";